import View from '../View';
import 'gsap/TweenMax';

/**
 * Preloader
 */
class Preloader extends View {
    /**
     * Header constructor
     * @param node
     */
    constructor(node) {
        super(node);


        const tl = new TimelineLite({
            onComplete: () => {
                node.classList.add('hidden');
            },
        });

        tl.to(node, 0.35, {
            opacity: 0,
            ease: Power3.easeInOut,
        }, '+=.15');
    }

}

export default Preloader;



// WEBPACK FOOTER //
// frontend/js/components/Preloader.js